import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent implements OnInit {
    basePath = window.location.href.split('#')[0];
    path = this.route.snapshot.url[0];
    url = `${this.basePath}#/${this.path}`;

    // Mensagens de acesso negado
    portal: string = '';
    permissions: string[] = [];

    constructor(private route: ActivatedRoute, private location: Location) {}

    ngOnInit() {
        // Lê dados da rota (data)
        this.route.data.pipe(take(1)).subscribe(data => {
            this.path = data.path;
            this.portal = data.portal || '';
            this.permissions = data.permissions || [];
        });

        // Lê parâmetros da query string (do guard)
        this.route.queryParams.pipe(take(1)).subscribe(params => {
            if (params['path']) {
                this.path = params['path'];
            }
            if (params['portal']) {
                this.portal = params['portal'];
            }
            if (params['permissions']) {
                this.permissions = params['permissions'].split(',');
            }
        });
    }

    goBack(): void {
        this.location.back();
    }

    /**
     * Verifica se o acesso foi negado devido ao portal
     */
    get isPortalDenied(): boolean {
        return !!this.portal;
    }

    /**
     * Verifica se o acesso foi negado devido a permissões
     */
    get isPermissionDenied(): boolean {
        return this.permissions.length > 0;
    }

    /**
     * Retorna mensagem personalizada sobre o motivo do acesso negado
     */
    get accessDeniedReason(): string {
        if (this.isPortalDenied && this.isPermissionDenied) {
            return `Você não tem acesso ao portal "${this.portal}" e também não possui as permissões necessárias para acessar esta funcionalidade.`;
        } else if (this.isPortalDenied) {
            return `Você não tem acesso ao portal "${this.portal}".`;
        } else if (this.isPermissionDenied) {
            return `Você não possui as permissões necessárias para acessar esta funcionalidade.`;
        } else {
            return 'Você não possui permissão para acessar esta funcionalidade.';
        }
    }
}
